<template>
  <SingleSelect
    v-model="selected"
    :searchable="true"
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :search-input.sync="search"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{index, item}">
      <span
        v-if="index === 0"
        class="grey--text caption"
      >
        {{ item }}
      </span>
    </template>
  </SingleSelect>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SingleSelect from '@/components/filter/models/SingleSelect';

export default {
  name: 'CategoryFilter',
  components: {
    SingleSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contract: {
      type: String,
      default: '',
    },
    bot: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      requestStatus: '',
      search: '',
      items: [],
      maxBotsAllowed: 1,
    };
  },
  computed: {
    label() {
      return this.$t('components.filters.CategoryFilter.label');
    },
    placeholder() {
      return this.$t('components.filters.CategoryFilter.placeholder');
    },
    ...mapState('filter', [
      'globalFilter',
    ]),
    selected: {
      get() {
        if (this.filter?.category?.value) {
          return this.filter.category.value;
        }
        return this.value?.value;
      },
      set(newValue) {
        if (!newValue || newValue.length === 0) {
          return this.$emit('input', undefined);
        }
        this.$emit('input', {
          value: newValue,
        });
      },
    },
  },
  watch: {
    'filter.bots': {
      handler(newBot, oldBot) {
        if (this.filter.bots?.value &&
            Boolean(this.filter.bots?.value?.length) &&
            (oldBot ? !this.filter.bots?.value.some(bot => {
              return newBot.value.includes(bot);
            }) : true)) {
          this.makeBlipServiceRequest(this.contract, newBot.value);
          this.selected = '';
        }
      },
      deep: true,
    },
    search(newValue) {
      this.debouncedServiceRequest(this.contract, this.bot, newValue);
    },
  },
  mounted() {
    this.bot ? this.makeBlipServiceRequest(this.contract, this.bot) : this.makeBlipServiceRequest();
    this.debouncedServiceRequest = this.debounce(this.makeBlipServiceRequest, 500);
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
    ]),
    makeBlipServiceRequest(contractFiltered, botFilteredKey, searchCategory) {
      const servicePath = 'getEventCategories';
      const take = '10';
      const category = searchCategory;
      const optionalParams = true;

      const options = { servicePath, take, contractFiltered, botFilteredKey, optionalParams };

      if (category !== undefined) {
        options.categoryFilter = category;
      }

      this.items = [];
      this.getBlipService(options)
        .then((response) => {
          this.items = response[0].resource.items.map(obj => obj.category);
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    debounce(func, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
  },
};

</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }
</style>
